let cartCount = document.querySelectorAll(".cart-count");

function fetchCart() {
  fetch("/cart.js")
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      cartCount.forEach((element) => {
        element.innerHTML = data.item_count > 0 ? data.item_count : "0";
      });
    })
    .catch((error) => {
      console.error("Error fetching cart:", error);
      cartCount.forEach((element) => {
        element.innerHTML = "0";
      });
    });
}

fetchCart();
document.addEventListener("ajaxProduct:added", fetchCart);
document.addEventListener("cart:updated", fetchCart);
